import { useEffect, useState } from 'react';
import { trackHelpDeskInterceptEvent } from '../events/trackHelpDeskInterceptEvent';
import { HelpDeskInterceptAlert } from './_internal/HelpDeskInterceptAlert';
import { useHasSeenInboxIntercept } from '../hooks/useHasSeenInboxIntercept';
import { useSetSeenInboxInterceptSetting } from '../hooks/useSetSeenInboxInterceptSetting';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaybeHelpDeskInboxIntercept = ({
  onTrack
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasSeenIntercept = useHasSeenInboxIntercept();
  const setSeenIntercept = useSetSeenInboxInterceptSetting();
  useEffect(() => {
    if (!hasSeenIntercept) {
      setIsOpen(true);
      setSeenIntercept(true);
      trackHelpDeskInterceptEvent({
        action: 'viewed interception',
        component: 'alert',
        onTrack
      });
    }
  }, [hasSeenIntercept, setSeenIntercept, onTrack]);
  const onClickGoToHelpDesk = () => {
    trackHelpDeskInterceptEvent({
      action: 'clicked go to help desk',
      component: 'alert',
      onTrack
    });
  };
  const onDismissIntercept = () => {
    setIsOpen(false);
    setSeenIntercept(true);
    trackHelpDeskInterceptEvent({
      action: 'dismissed interception',
      component: 'alert',
      onTrack
    });
  };
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(HelpDeskInterceptAlert, {
    onClickGoToHelpDesk: onClickGoToHelpDesk,
    onDismiss: onDismissIntercept
  });
};
MaybeHelpDeskInboxIntercept.displayName = 'MaybeHelpDeskInboxIntercept';